import { atom } from 'jotai';
import { SKU_EP133 } from '~/lib/constants';

export const deviceSkuAtom = atom<string>(SKU_EP133);
